const init = (superclass) => {
    return class R_GridChild extends superclass {
    };
};

export default init;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/child/grid/R_GridChild.js